export default __webpack_public_path__ + "static/media/create-icon.73cad61f.svg";